import {RoboyuSkin} from 'types'

export const ROBOYU_SENSITIVITY_LEVEL_DEFAULT = 5
export const ROBOYU_SENSITIVITY_LEVEL_MAX = 9
export const ROBOYU_SENSITIVITY_LEVEL_MIN = 1

export const ROBOYU_RETAKE_DAILY_LIMIT = 3

export const ROBOYU_MAX_LEVEL = 35

export const ROBOYU_COLOR_THEME: RoboyuSkin[] = [
  {name: 'blue', skin_id: ''},
  {name: 'light_blue', skin_id: ''},
  {name: 'yellow', skin_id: ''},
  {name: 'orange', skin_id: ''},
  {name: 'red', skin_id: ''},
  {name: 'pink', skin_id: ''},
  {name: 'green', skin_id: ''},
  {name: 'purple', skin_id: ''},
]
